export default {
	data() {
		return {
			filterCustomer: {
				name: "",
				_id: ""
			}
		};
	},
	watch: {
		"filterCustomer._id": {
			handler(val) {
				let fieldName = "customer";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	}
};
